import React, { useState, useEffect } from 'react';

export const ModerationContext = React.createContext({});
ModerationContext.displayName = 'Moderation';

export const ModerationContextProvider = ({
  removedList = [],
  bannedList = [],
  hiddenList = [],
  children,
}) => {
  const [moderationState, setModerationState] = useState({ removedList, bannedList, hiddenList });

  useEffect(() => {
    setModerationState({ removedList, bannedList, hiddenList });
  }, [removedList, bannedList, hiddenList]);

  return (
    <ModerationContext.Provider
      value={{
        moderationState,
        setModerationState,
      }}
    >
      {children}
    </ModerationContext.Provider>
  );
};
